import LayoutModule from './layout.module'

export default LayoutModule
